import { render } from "./aliPay.vue?vue&type=template&id=66d76447"
import script from "./aliPay.vue?vue&type=script&lang=js"
export * from "./aliPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__